import React from "react";
import { Icon } from "assets/icons/Icon";
import {
	DropdownItem,
	DropdownMenu,
	DropdownMenuDrawer,
	DropdownMenuTrigger,
	MenuDivider,
} from "components/RFQ/MenuDropdown";
import { Template } from "types/template";

type TemplateActionsButtonProps = {
	templateId: number;
	template: Template;
	onEdit: () => void;
	onLock: () => void;
	onArchive: () => void;
	onDelete: () => void;
};

const TemplateActionsButton = ({
	templateId,
	template,
	onEdit,
	onLock,
	onArchive,
	onDelete,
}: TemplateActionsButtonProps) => {
	const isLocked = template.status === "locked";
	const isArchived = template.status === "archived";
	const canDelete = template.status !== "locked";

	const menuItems = [
		{
			name: "Edit Template",
			icon: "edit-icon",
			action: onEdit,
			divider: false,
			show: !isLocked,
		},
		{
			name: isLocked ? "Active Template" : "Lock Template",
			icon: isLocked ? "template" : "lock",
			action: onLock,
			divider: false,
			show: true,
		},
		{
			name: isArchived ? "Active Template" : "Archive Template",
			icon: isArchived ? "template" : "archive",
			action: onArchive,
			divider: true,
			show: true,
		},
		{
			name: "Delete Template",
			icon: "trash-03",
			action: onDelete,
			divider: false,
			show: canDelete,
		},
	].filter((item) => item.show);

	return (
		<div>
			<DropdownMenu className="flex justify-end">
				<DropdownMenuTrigger icon>
					<div />
				</DropdownMenuTrigger>
				<DropdownMenuDrawer>
					{menuItems.map((menu, index) => (
						<div key={index}>
							<DropdownItem
								className="w-full cursor-pointer"
								onClick={menu.action}
							>
								<Icon
									icon={menu.icon}
									width={16}
									height={16}
									style={{
										color: menu.icon === "trash-03" ? "#EF4444" : "#344054",
									}}
								/>
								<p
									className={`font-roboto text-[14px] font-medium hover:text-[14px] ${
										menu.icon === "trash-03"
											? "text-red-600"
											: "text-secondary-700"
									}`}
									style={{ lineHeight: "20px" }}
								>
									{menu.name}
								</p>
							</DropdownItem>
							{menu.divider && <MenuDivider />}
						</div>
					))}
				</DropdownMenuDrawer>
			</DropdownMenu>
		</div>
	);
};

export default TemplateActionsButton;
